/* @flow */
import type { $WidgetField } from 'CoreTypes/WidgetField';
import Keys from './WidgetFieldsKeys';

export const WidgetFieldSource = {
  DEALER: 'dealer',
  CONFIG: 'configuration'
};

export default ([
  {
    fkey: Keys.HEADLINE_WIDGET,
    label: 'Widget headline',
    id: 'dl-dsw-widget-headline',
    translatable: true
  },
  {
    fkey: Keys.BUTTON_LOCATE_ME_TOOLTIP,
    label: 'Locate me button tooltip text',
    id: 'dl-dsw-button-locate-me-tooltip',
    translatable: true
  },
  {
    fkey: Keys.INPUT_SEARCH_PLACEHOLDER,
    label: 'Search input placeholder text',
    id: 'dl-dsw-input-search-placeholder',
    translatable: true
  },
  {
    fkey: Keys.BUTTON_SEARCH,
    label: 'Search button text',
    id: 'dl-dsw-button-search',
    translatable: true
  },
  {
    fkey: Keys.PARAGRAPH_RESULTS_COUNT,
    label: 'Paragraph showing results count',
    id: 'dl-dsw-paragraph-results-count',
    translatable: true
  },
  {
    fkey: Keys.PARAGRAPH_RESULTS_COUNT_SINGULAR,
    label: 'Paragraph showing results count',
    id: 'dl-dsw-paragraph-results-count',
    translatable: true
  },
  {
    fkey: Keys.PARAGRAPH_RESULTS_SUGGESTED_COUNT,
    label: 'Results count and suggested criteria',
    id: 'dl-dsw-paragraph-results-count-suggested',
    translatable: true
  },
  {
    fkey: Keys.PARAGRAPH_SEARCH_INSTEAD_LINK,
    label: 'Text for original search expression link',
    id: 'dl-dsw-paragraph-search-instead',
    translatable: true
  },
  {
    fkey: Keys.TAB_MODE_LIST,
    label: 'List mode tab text',
    id: 'dl-dsw-tab-mode-list',
    translatable: true
  },
  {
    fkey: Keys.TAB_MODE_MAP,
    label: 'Map mode tab text',
    id: 'dl-dsw-tab-mode-map',
    translatable: true
  },
  {
    fkey: Keys.DROPDOWN_FILTER,
    label: 'Filter dropdown label',
    id: 'dl-dsw-dropdown-filter',
    translatable: true
  },
  {
    fkey: Keys.FILTERING_ACTIVITY_TYPES_LABEL,
    label: 'Activity type filter dropdown placeholder text',
    id: 'dl-dsw-dropdown-filter-placeholder',
    translatable: true
  },
  {
    fkey: Keys.FILTERING_PRODUCT_GROUPS_LABEL,
    label: 'Product group filter dropdown placeholder text',
    id: 'dl-dsw-dropdown-filter-placeholder',
    translatable: true
  },
  {
    fkey: Keys.BUTTON_DEALER_SELECT,
    label: 'Select dealer button text',
    id: 'dl-dsw-button-dealer-select',
    translatable: true
  },
  {
    fkey: Keys.PREFIX_PHONE,
    label: 'Prefix for phone number',
    id: 'dl-dsw-prefix-phone',
    translatable: true
  },
  {
    fkey: Keys.PREFIX_FAX,
    label: 'Prefix for fax number',
    id: 'dl-dsw-prefix-fax',
    translatable: true
  },
  {
    fkey: Keys.PREFIX_EMAIL,
    label: 'Prefix for email address',
    id: 'dl-dsw-prefix-email',
    translatable: true
  },
  {
    fkey: Keys.HERE_MAPS_LANGUAGE,
    label: 'HERE maps language',
    id: 'dl-dsw-here-maps-language',
    translatable: true
  },
  {
    fkey: Keys.DEALERS_SEARCH_TAB_LABEL_LOCATION,
    label: 'Dealers search tab label: by location',
    id: 'dl-dealers-search-tab-location',
    translatable: true
  },
  {
    fkey: Keys.DEALERS_SEARCH_TAB_LABEL_NAME,
    label: 'Dealers search tab label: by name',
    id: 'dl-dealers-search-tab-name',
    translatable: true
  },
  {
    fkey: Keys.DEALERS_SEARCH_SUBMIT_BUTTON_LABEL,
    label: 'Dealers search form submit button label',
    id: 'dl-dealers-search-submit-label',
    translatable: true
  },
  {
    fkey: Keys.DEALERS_SEARCH_FIELD_NO_SUGGESTIONS,
    label: 'No suggestions found label',
    id: 'dl-dealers-search-no-suggestions-label',
    translatable: true
  },
  {
    fkey: Keys.DEALERS_SEARCH_FIELD_PLACEHOLDER_LOCATION,
    label: 'Dealers search input field placeholder: location',
    id: 'dl-dealers-search-field-placeholder-location',
    translatable: true
  },
  {
    fkey: Keys.DEALERS_SEARCH_FIELD_PLACEHOLDER_NAME,
    label: 'Dealers search input field placeholder: name',
    id: 'dl-dealers-search-field-placeholder-name',
    translatable: true
  }
]: Array<$WidgetField>);
